<div class="modal-container">
  <div class="edit-fac-container">  
    <p class="title">Usuário</p>

    <app-autocomplete
      inputId="destination-component-2"
      placeholder="Usuário"
      [showSearch]="false"
      maxLength="200"
      [autoSearchResults]="autocomplete" 
      (ElementSelected)="setElement($event)"
      (autocompleteSearch)="searchElement($event)" value="description"
      [enhanveOnHover]="true">
    </app-autocomplete>

    <div class="footer-action">
      <lib-button-tertiary id="user-modal-cancel" (click)="closeModal.emit()">Cancelar</lib-button-tertiary>
      <lib-button-primary id="user-modal-add" [isDisabled]="disableSave" (click)="!disableSave ? save() : null">Adicionar</lib-button-primary>
    </div>
  </div>
</div>
